import { Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { HomePage } from './pages/HomePage'
import { LessonsPage } from './pages/LessonsPage'
import { PrivacyPage } from './pages/PrivacyPage'
import { WeddingPage } from './pages/WeddingPage'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/oprawa-wokalna" element={<WeddingPage />} />
        <Route path="/lekcje-spiewu" element={<LessonsPage />} />
        <Route path="/polityka-prywatnosci" element={<PrivacyPage />} />
        <Route path="/index.html" element={<Navigate to="/" replace />} />
        <Route path="/oprawawokalna.html" element={<Navigate to="/oprawa-wokalna" replace />} />
        <Route path="/naukaspiewu.html" element={<Navigate to="/lekcje-spiewu" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
